import { render, staticRenderFns } from "./StylePage.vue?vue&type=template&id=196a2b7d&scoped=true&"
import script from "./StylePage.vue?vue&type=script&lang=js&"
export * from "./StylePage.vue?vue&type=script&lang=js&"
import style0 from "./StylePage.vue?vue&type=style&index=0&id=196a2b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a2b7d",
  null
  
)

export default component.exports